import $ from 'jquery';


const toggleGallery = (toggleButtonContainer) => {
	toggleButtonContainer.find(".js-galleryToggleButton").each(function() {
		const targetSelectorNam = "."+$(this).attr("data-target");
		if($(this).hasClass("active" )){
			toggleButtonContainer.find(targetSelectorNam).show();
		}else{
			toggleButtonContainer.find(targetSelectorNam).hide();
		}
	});

};

export const initToggleGallery = () => {
	const galleryToggleBtnSel = $(".js-galleryToggleButton");
	if(galleryToggleBtnSel.length>0){
		toggleGallery($(".js-galleryToggleSet"));
		galleryToggleBtnSel.on("click", function(){
			galleryToggleBtnSel.removeClass('active');
			$(this).addClass('active');
			toggleGallery($(this).closest(".js-galleryToggleSet"));
		});
	}
}